<template>
  <div class="change-log-component">
    <v-dialog
      v-model="changeLog.show"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar
          dark
          color="primary">
          <v-btn
            icon
            dark
            @click="onCloseChangeLog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Change Logs</v-toolbar-title>
        </v-toolbar>
        <v-container
          fluid
          class="mt-2">
          <v-layout>
            <v-flex md2>
              <v-menu
                v-model="startDateModal"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="changeLog.startDate"
                    label="Start Date"
                    prepend-icon="event"
                    clearable
                    readonly
                    v-on="on"
                  />
                </template>
                <v-date-picker
                  v-model="changeLog.startDate"
                  @input="startDateModal = false"/>
              </v-menu>
            </v-flex>
            <v-flex md2>
              <v-menu
                v-model="endDateModal"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="changeLog.endDate"
                    label="End Date"
                    prepend-icon="event"
                    clearable
                    readonly
                    v-on="on"
                  />
                </template>
                <v-date-picker
                  v-model="changeLog.endDate"
                  @input="endDateModal = false"/>
              </v-menu>
            </v-flex>
            <v-flex md2>
              <v-select
                :items="[{text: 'All', value: 'all'}, { text: 'Inventory', value: 'account-inventory'}, { text: 'Oppreg', value: 'oppreg'}, { text: 'Customer', value: 'customer'}, { text: 'API', value: 'None'}]"
                v-model="changeLog.module"
                label="Module"
                prepend-icon="domain"
              />
            </v-flex>
            <v-flex md2>
              <v-select
                :items="[{text: 'All', value: 'all'}, {text: 'Add', value: 'Add'}, {text: 'Update', value: 'Update'}, {text: 'Discount Update', value: 'DiscountUpdate'}]"
                v-model="changeLog.action"
                label="Action"
                prepend-icon="domain"
              />
            </v-flex>
            <v-flex md1>
              <v-checkbox
                v-model="changeLog.highlight"
                value="1"
                color="orange"
                label="Highlight Changes"
                @change="clearSearch"
              />
            </v-flex>
            <v-flex md2 v-if="!changeLog.highlight">
              <v-text-field
                v-model="search"
                label="Search"
                single-line
                hide-details
                append-icon="search"
              />
            </v-flex>
            <v-flex v-if="!changeLog.highlight">
              <Can
                I="manage"
                a="reports">
                <v-flex style="text-align: right">
                  <HelperCsvDownload
                    :data="getLogRecords"
                    :getData="getFilteredLogs"
                    :title="'Changelog'"
                    @csv-download-success="downloadFinished"
                  />
                </v-flex>
              </Can>
            </v-flex>
          </v-layout>
          <v-progress-linear
            v-if="changeLog.loading"
            color="orange"
            indeterminate/>
          <v-data-table
            ref="changelogList"
            :search="search"
            :headers="changeLog.headers"
            :items="getLogRecords"
            :pagination.sync="pagination"
            class="elevation-1"
            item-key="Log_Id"
          >
            <template v-slot:items="props">
              <td>
                <a
                  v-if="props.item.Record_Module !== 'None'"
                  href="#"
                  @click="openRecord(props.item.Record_Module, props.item.Record_Id)">
                  {{ props.item.Log_Id }}
                </a>
                <span v-else>
                  {{ props.item.Log_Id }}
                </span>
              </td>
              <td>{{ (props.item.action === 'API') ? "Validation Update via API" : props.item.action }}</td>
              <td>{{ props.item.User }}</td>
              <td v-if="changeLog.highlight">
                <pre v-html="props.item.Change_From" />
              </td>
              <td v-else>{{ props.item.Change_From }}</td>
              <td v-if="changeLog.highlight">
                <pre v-html="props.item.Change_To" />
              </td>
              <td v-else>{{ props.item.Change_To }}</td>
              <td>{{ props.item.Create_Date }}</td>
            </template>
          </v-data-table>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>

import { mapState, mapGetters, mapMutations } from 'vuex'

export default {
  data () {
    return {
      startDateModal: false,
      endDateModal: false,
      pagination: {
        descending: true,
        sortBy: 'Log_Id',
        page: 1,
        rowsPerPage: 10,
        totalItems: 0
      },
      logModule: 'all',
      search: ''
    }
  },
  computed: {
    ...mapState(['changeLog']),
    ...mapGetters(['getLogRecords'])
  },
  methods: {
    ...mapMutations({
      resetChangeLog: 'resetChangeLog',
    }),
    openRecord (module, id) {
      this.changeLog.show = false
      if (module === 'oppreg') {
        this.$router.push({ path: `/admin/oppreg-administration/admin-content/${id}` })
      } else if (module === 'account-inventory') {
        let record = this.$store.state['admin/accountInventory'].accountData.filter(account => account.Acct_ID === id)
        this.$store.commit('admin/openAccountDialog', {
          show: true,
          type: 'edit',
          showSelectCustomer: false,
          fields: { ...record[0] },
          accountIdExist: true,
          mpIdExist: true,
          submitLabel: 'Update',
          submitHandler: () => {
            this.$store.dispatch('admin/updateAccount')
          }
        })
        this.$store.commit('setChangeLogRecord', { id: record[0].Acct_ID, changeFrom: { ...record[0] } }, { root: true })
      }
    },
    getFilteredLogs () {
      this.pagination.rowsPerPage = -1
      let data = this.$refs.changelogList.filteredItems
      this.pagination.rowsPerPage = 10
      return data
    },
    clearSearch () {
      this.search = ''
    },
    downloadFinished () {
      console.log('download finished')
      this.pagination.rowsPerPage = 10
    },
    onCloseChangeLog () {
      this.resetChangeLog()
    }
  }
}
</script>
